import Cookies from 'js-cookie';

import {AUTH_TOKEN_DOMAIN, AUTH_TOKEN_EXPIRES, AUTH_TOKEN_KEY} from './constants';

// Browsers silently reject Set-Cookie when the `domain` attribute isn't a
// suffix of the page's host. On hosts outside the auth zone (e.g. staging at
// `*.herokuapp.com`, local dev), fall back to a current-host cookie so the
// token is actually persisted. Cross-app SSO via the parent-domain cookie
// still works on hosts inside the auth zone.
const isHostInAuthDomain = (): boolean => {
  if (!AUTH_TOKEN_DOMAIN) return false;
  const zone = AUTH_TOKEN_DOMAIN.replace(/^\./, '');
  const host = window.location.hostname;
  return host === zone || host.endsWith('.' + zone);
};

export const setToken = (token: string) => {
  if (isHostInAuthDomain()) {
    Cookies.set(AUTH_TOKEN_KEY, token, {
      domain: AUTH_TOKEN_DOMAIN,
      expires: AUTH_TOKEN_EXPIRES,
    });
  } else {
    Cookies.set(AUTH_TOKEN_KEY, token, {
      expires: AUTH_TOKEN_EXPIRES,
    });
  }
};

export const removeToken = () => {
  if (isHostInAuthDomain()) {
    Cookies.remove(AUTH_TOKEN_KEY, {domain: AUTH_TOKEN_DOMAIN});
  } else {
    Cookies.remove(AUTH_TOKEN_KEY);
  }
};

export const getToken = (): string | undefined => {
  return Cookies.get(AUTH_TOKEN_KEY);
};
